import { render, staticRenderFns } from "./AdminOlimpiadaShow.vue?vue&type=template&id=069fa1ec&scoped=true"
import script from "./AdminOlimpiadaShow.vue?vue&type=script&lang=js"
export * from "./AdminOlimpiadaShow.vue?vue&type=script&lang=js"
import style0 from "./AdminOlimpiadaShow.vue?vue&type=style&index=0&id=069fa1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069fa1ec",
  null
  
)

export default component.exports